import {
  TICKET_SUMMARY_COLUMN_DEFINITIONS,
  normalizeRenderConfig,
  sortReportRows,
} from "./renderConfig";
import { buildCsv } from "./agentServiceTimeExport";

const SUMMARY_HEADERS = Object.freeze([
  "Scope",
  "Total Tickets",
  "Average",
  "Min",
  "Max",
  "Completed",
  "Completed %",
  "No Show",
  "No Show %",
  "Unattended",
  "Unattended %",
]);
const BREAKDOWN_HEADERS = Object.freeze(["Scope", "Period", "Total", "Completed", "No Show", "Unattended"]);

const toPrimitiveNumber = (value) => {
  const numericValue = Number(value);
  return Number.isFinite(numericValue) ? numericValue : 0;
};

const getPointPeriod = (point) => point.date ?? point.day ?? point.name ?? point.hour ?? "";

export const getTicketSummaryRows = (scopes = [], renderConfig) => {
  const config = normalizeRenderConfig(renderConfig, {
    columnDefinitions: TICKET_SUMMARY_COLUMN_DEFINITIONS,
  });
  return sortReportRows(scopes, config, {
    columnDefinitions: TICKET_SUMMARY_COLUMN_DEFINITIONS,
  });
};

export const getTicketSummaryCsvRows = (scopes = [], renderConfig) =>
  getTicketSummaryRows(scopes, renderConfig).map((row) => [
    row.scopeName || row.branchName || row.name || "",
    toPrimitiveNumber(row.total ?? row.totalTickets),
    toPrimitiveNumber(row.average ?? row.averageTicketsPerDay ?? row.averageTicketsPerHour),
    toPrimitiveNumber(row.min ?? row.minTicketsPerDay ?? row.minTicketsPerHour),
    toPrimitiveNumber(row.max ?? row.maxTicketsPerDay ?? row.maxTicketsPerHour),
    toPrimitiveNumber(row.completed),
    toPrimitiveNumber(row.completedPct ?? row.pctCompleted),
    toPrimitiveNumber(row.noShow ?? row.totalNoShow),
    toPrimitiveNumber(row.noShowPct ?? row.pctNoShow),
    toPrimitiveNumber(row.unattended ?? row.totalUnattended),
    toPrimitiveNumber(row.unattendedPct ?? row.pctUnattended),
  ]);

export const getTicketSummaryBreakdownCsvRows = (scopes = [], renderConfig) =>
  getTicketSummaryRows(scopes, renderConfig).flatMap((row) =>
    (row.chart || []).map((point) => [
      row.scopeName || row.branchName || row.name || "",
      getPointPeriod(point),
      toPrimitiveNumber(point.total),
      toPrimitiveNumber(point.completed),
      toPrimitiveNumber(point.no_show ?? point.noShow),
      toPrimitiveNumber(point.unattended),
    ])
  );

const triggerCsvDownload = (filename, csv) => {
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(link.href);
};

export const downloadTicketSummaryCsvFiles = ({ scopes, renderConfig, filenamePrefix }) => {
  triggerCsvDownload(
    `${filenamePrefix}_summary.csv`,
    buildCsv(SUMMARY_HEADERS, getTicketSummaryCsvRows(scopes, renderConfig))
  );
  triggerCsvDownload(
    `${filenamePrefix}_breakdown.csv`,
    buildCsv(BREAKDOWN_HEADERS, getTicketSummaryBreakdownCsvRows(scopes, renderConfig))
  );
};
